import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="relative border-t border-white/10 bg-[#080E18] overflow-hidden" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
                <div className="flex flex-col md:flex-row justify-between gap-10">
                    <div className="max-w-sm">
                        <img
                            src="/logo-horizontal-dark.webp"
                            alt="Trout Start"
                            className="h-16 w-auto rounded-xl"
                            data-testid="footer-logo"
                        />
                        <p className="mt-5 font-body text-sm leading-relaxed text-slate-400">
                            Field guides, interactive checklists, and honest gear picks for fly anglers chasing trout.
                        </p>
                    </div>

                    <nav className="grid grid-cols-2 gap-x-16 gap-y-3" data-testid="footer-nav">
                        <Link to="/fly-fishing" data-testid="footer-link-fly-fishing" className="font-sans text-sm text-slate-300 hover:text-teal transition-colors">Fly Fishing</Link>
                        <Link to="/checklists" data-testid="footer-link-checklists" className="font-sans text-sm text-slate-300 hover:text-teal transition-colors">Checklists</Link>
                        <Link to="/journal" data-testid="footer-link-journal" className="font-sans text-sm text-slate-300 hover:text-teal transition-colors">Field Journal</Link>
                        <Link to="/identify-my-fly" data-testid="footer-link-identify-fly" className="font-sans text-sm text-slate-300 hover:text-teal transition-colors">Identify My Fly</Link>
                        <Link to="/gear" data-testid="footer-link-gear" className="font-sans text-sm text-slate-300 hover:text-teal transition-colors">Gear & Affiliates</Link>
                    </nav>
                </div>

                <p className="mt-14 font-serif text-[13vw] md:text-[9vw] leading-none font-bold text-outline select-none whitespace-nowrap" aria-hidden="true">
                    TROUT START
                </p>

                <div className="mt-10 flex flex-col sm:flex-row justify-between gap-4 border-t border-white/10 pt-6">
                    <p className="font-body text-xs text-slate-500 max-w-2xl">
                        Affiliate disclosure: TroutStart.com participates in affiliate programs, including Amazon Associates. When you buy through our links we may earn a commission at no extra cost to you — it keeps the waders patched and the guides free. As an Amazon Associate we earn from qualifying purchases.
                    </p>
                    <p className="font-mono text-xs text-slate-500 shrink-0">© 2026 TroutStart.com</p>
                </div>
            </div>
        </footer>
    );
}
